<template>
  <RevCard :id="item.listingId" class="p-24" data-qa="cart">
    <Product
      :item
      :quantity
      @remove="emit('remove')"
      @update-quantity="(quantity) => emit('update-quantity', quantity)"
    />

    <!-- This slot exists only during the migration , it'll be removed once CartItemCard fully migrated -->
    <slot />
  </RevCard>
</template>

<script setup lang="ts">
import type { CartItem } from '@backmarket/http-api/src/api-specs-checkout/cart/cart.types'
import { RevCard } from '@ds/components/Card'

import Product from './components/Product/Product.vue'

defineProps<{
  item: CartItem
  quantity: number
}>()

const emit = defineEmits<{
  remove: []
  'update-quantity': [quantity: number]
}>()
</script>
